/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, January 16th 2023, 9:27:53 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder } from "lib/validation";
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
} from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";

export interface DataBank extends ProcessTemplateArtifact, WritableModel<true> {
  name: string;
  description?: string;
  readonly created_at?: string;
  readonly updated_at?: string;
}

type WriteOnlyDataBank = Omit<DataBank, "id" | "created_at" | "updated_at">;

export const DataBankValidationSchema: ProcessTemplateArtifactSchemaType<WriteOnlyDataBank> =
  ProcessTemplateArtifactValidationSchema.shape({
    name: schemaBuilder.string().required("You must provide the name for a Databank."),
    description: schemaBuilder.string().nullable().optional(),
  });
